import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { DetailAlamat } from 'src/app/interfaces/api/alamat';
import { ProductService } from 'src/app/services/product.service';
import { forkJoin } from 'rxjs';
import { ProfileService } from 'src/app/services/profile.service';
import { FullAddressJSON } from 'src/app/interfaces/address';

@Component({
  selector: 'app-modal-quickselect-alamat',
  templateUrl: './modal-quickselect-alamat.component.html',
  styleUrls: ['./modal-quickselect-alamat.component.scss'],
})
export class ModalQuickselectAlamatComponent implements OnInit {
  listAlamat: DetailAlamat[];
  selectedAlamat: DetailAlamat;
  isLoading = true;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private profileService: ProfileService,
  ) {}

  ngOnInit() {
    this.loadData(null);
  }

  loadData(event) {
    this.isLoading = true;
    const alamatReq = this.profileService.getAlamat();

    forkJoin([alamatReq]).subscribe({
      next: async ([alamatRes]) => {
        console.log(alamatRes.customer_addresses);
        this.listAlamat = alamatRes.customer_addresses.sort((a, b) => b.is_primary - a.is_primary).slice(0, 2);
        this.selectedAlamat = this.listAlamat.find(alamat => alamat.is_primary === 1);
      },
      complete: () => {
        this.isLoading = false;
        event?.target?.complete();
      },
    });
  }

  confirmSelectAlamat(alamat: DetailAlamat) {
    this.selectedAlamat = alamat;
    this.updatePilihAlamat();
    this.modalController.dismiss({ selectedAlamat: this.selectedAlamat }, 'confirm');
  }

  updatePilihAlamat() {
    if (this.selectedAlamat) {
      this.profileService.updateAlamatToActive(this.selectedAlamat.id).subscribe({
        next: async (val: any) => {
          console.log(val);
        },
        error: err => {
          console.error(err);
        },
        complete: () => {},
      });
    }
  }

  goToListAlamatPage() {
    this.navController.navigateForward('/list-alamat');
    this.close();
  }

  addAddress() {
    this.navController.navigateForward('/add-address');
    this.close();
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  close() {
    this.modalController.dismiss(null, 'close');
  }

  getFullAddress(address_data: string) {
    let address = '';

    try {
      const full_address = JSON.parse(address_data) as FullAddressJSON;
      address = full_address?.address;
    } catch (error) {
      address = address_data;
    }

    return address;
  }
}
